var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_sueecss_pc"},[_c('div',{staticClass:"sueecss_box"},[_c('div',{staticClass:"dialog-close"},[_c('i',{staticClass:"el-icon-close",on:{"click":function () { return this$1.$emit('closeform'); }}})]),_c('img',{attrs:{"src":_vm.retainImg,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }